import { gql } from '@apollo/client'

const MutationDeleteAssetFiles = gql(`
    mutation deleteAssetFiles($input: [ID],  $assetId: ID, $project: String) {
        deleteAssetFiles(
            input: $input,
            assetId: $assetId,
            project: $project
        )
    }`
)

export default MutationDeleteAssetFiles
